import React, { useState, useRef } from 'react';
import useStore from 'state/state';
import StandardButton from 'components/StandardButton/StandardButton';
import clsx from 'clsx';
import { func, arrayOf, any, string } from 'prop-types';
import ContactFormParser from 'utils/contactFormParser';
import GTMTracker from 'tracking/gtm-tracker';
import Input from './Input/Input';
import styles from './Form.module.scss';
import Checkbox from './Checkbox/Checkbox';

// eslint-disable-next-line no-unused-vars
const Form = ({ fields, onSend, productAlias }) => {
  const appData = useStore((state) => state.appData);
  const contactFormData = useStore((state) => state.contactFormData);
  const [, setFormValid] = useState(false);
  const refs = useRef([]);

  const createRefs = (length) => {
    refs.current = Array(length)
      .fill()
      .map((_, index) => refs.current[index] || React.createRef());
  };

  const checkValidation = () => {
    let valid = true;
    refs.current.forEach((r) => {
      console.log(r);
      if (r.current) {
        const notValid = r.current.validate();
        if (notValid) {
          valid = false;
        }
      }
    });

    setFormValid(valid);
    if (valid) {
      const obj = { values: {} };
      refs.current.forEach((r) => {
        if (r.current) {
          const v = r.current.getValue();
          obj.values[v.name] = v.value;
        }
      });
      obj.values.productAlias = productAlias;
      GTMTracker.push('submit', contactFormData.name, '', 'forms');
      onSend(obj);
    }
  };
  createRefs(fields.length);

  return (
    <div className={styles.wrapper}>
      {fields &&
        fields.map((field, i) => (
          <div className={styles.row} key={field.id}>
            {ContactFormParser.checkIfFieldIsInputText(field.type.name) && (
              <>
                <span className={styles.label}>
                  {field.caption} {field.required && <span>*</span>}
                </span>
                <Input
                  ref={refs.current[i]}
                  name={field.alias}
                  tabIndex={i}
                  placeholder={field.placeholder}
                  errorMessage={field.patternInvalidErrorMessage}
                  errorPattern={field.pattern}
                  required={field.required}
                  inputType={ContactFormParser.getFieldTypeByUmbracoName(
                    field.type.name
                  )}
                />
              </>
            )}

            {ContactFormParser.checkIfFieldTypeIsCheckbox(field.type.name) && (
              <>
                <span className={styles.label}>
                  {field.caption} {field.required && <span>*</span>}
                </span>
                <Checkbox
                  ref={refs.current[i]}
                  label={field.helpText}
                  tabIndex={i}
                  name={field.alias}
                  required={field.required}
                  errorMessage={field.patternInvalidErrorMessage}
                />
              </>
            )}
          </div>
        ))}
      <div className={clsx(styles.row)}>
        <div className={styles.col}>
          <StandardButton
            className={styles.submitBtn}
            label={contactFormData.submitLabel}
            icon="startArrow"
            onClick={() => {
              checkValidation();
            }}
            iconAlignRight
          />
        </div>
        <div className={styles.col}>
          <span className={styles.reqLabel}>
            * {appData.mainData.contactForm.mandatoryFieldsText}
          </span>
        </div>
      </div>
    </div>
  );
};

Form.propTypes = {
  onSend: func.isRequired,
  productAlias: string.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  fields: arrayOf(any).isRequired,
};

export default Form;
